<div class="sensor_threshold_popup foroverflow">
  <div class="modal-header">
    <h4 class="modal-title">Sensor Threshold Value</h4>
  </div>
  <!-- <div class="header">
    <div class="playerOne">Fault Determination Criteria:</div>
    <div class="playerTwo">
      <section class="fft-base-section">
        <mat-radio-group [(ngModel)]="fftBaseValue" (change)="onChangeFFTBaseValue()">
          <mat-radio-button class="r1-btn-margin" value="AC">
            Acceleration
          </mat-radio-button>
          <mat-radio-button class="r2-btn-margin" value="VEL">
            Velocity
          </mat-radio-button>
        </mat-radio-group>
      </section>
    </div>
  </div> -->

  <p style="font-size: 12px; margin-left: 16px; margin-bottom: 0px; margin-top: 20px;">
    Note: Vibration severity thresholds as per the ISO 10816. Users can change
    the thresholds, if so required
  </p>

  <div class="modal-body">
    <div class="table-responsive">
      <table class="table">
        <thead>
          <tr>
            <th>Sensor Group</th>
            <th>Range</th>
            <th>Green</th>
            <th>Yellow</th>
            <th>Red</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let _Sensor of _sensorGroupData; let i = index">
            <td *ngIf="_Sensor.metric_type !== 'sound' && _Sensor.metric_type !== 'gear_velocity'"
              id="title_value_{{ i }}">
              {{ _Sensor.metric_type }}
            </td>
            <td *ngIf="_Sensor.metric_type === 'sound'" id="title_value_{{ i }}">
              Delta Ultrasound (dB)
            </td>
            <td *ngIf="_Sensor.metric_type === 'gear_velocity'" id="title_value_{{ i }}">
              Velocity
            </td>
            <td>
              <div class="flexnalign">
                <div class="input-group width_70 m_r_10">
                  <input type="text" id="base_value_{{ i }}" value="{{ _Sensor.base_value }}" class="form-control"
                    (input)="onInputChange()" placeholder="Min" />
                </div>
                <div class="input-group width_70">
                  <input type="number" id="max_value_{{ i }}" value="{{ _Sensor.max_value }}" class="form-control"
                    (input)="onInputChange()" placeholder="Max" />
                </div>
              </div>
            </td>
            <td>
              <div class="input-group width_100">
                <input type="number" id="threshold_1_{{ i }}" value="{{ _Sensor.threshold_1 }}"
                  (input)="onInputChange()" class="form-control" />
                <div class="input-group-append">
                  <span class="input-group-text">%</span>
                </div>
              </div>
            </td>
            <td>
              <div class="flexnalign">
                <div class="input-group width_100">
                  <input type="number" id="threshold_2_{{ i }}" value="{{ _Sensor.threshold_2 }}"
                    (input)="onInputChange()" class="form-control" />
                  <div class="input-group-append">
                    <span class="input-group-text">%</span>
                  </div>
                </div>
              </div>
            </td>
            <td class="text-center">
              <div class="input-group width_100">
                <input type="number" id="threshold_3_{{ i }}" value="{{ _Sensor.threshold_3 }}"
                  (input)="onInputChange()" class="form-control" disabled/>
                <div class="input-group-append">
                  <span class="input-group-text">%</span>
                </div>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <h4 class="sub-title">Velocity Threshold</h4>
    <div class="table-responsive">
      <table class="table">
        <thead>
          <tr>
            <th *ngIf="assetType === 'MOTOR'">Machine Rating</th>
            <th *ngIf="assetType === 'PUMP'">Machine Rating</th>
            <th *ngIf="assetType === 'COMPRESSOR'">Machine Rating</th>
            <th *ngIf="assetType === 'JOURNAL_BEARING'">Machine Rating</th>
            <th *ngIf="assetType === 'FAN_BLOWER'">Machine Rating</th>
            <th *ngIf="assetType === 'GEAR'">Gear Velocity Threshold</th>
            <th>Green<span>(mm/sec)</span></th>
            <th>Yellow<span>(mm/sec)</span></th>
            <th>Red<span>(mm/sec)</span></th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let sensorkw of sensorKWpowerGroupData; let idx = index">
            <td *ngIf="sensorkw.metric_type === 'kwrating1'">
              < 15KW</td>
            <td *ngIf="sensorkw.metric_type === 'kwrating2'">15 - 75KW</td>
            <td *ngIf="sensorkw.metric_type === 'kwrating3' && assetType === 'FAN_BLOWER'"> > 75KW </td>
            <td *ngIf="sensorkw.metric_type === 'kwrating3' && assetType === 'MOTOR'"> > 75KW </td>
            <td *ngIf="sensorkw.metric_type === 'kwrating3' && assetType === 'PUMP'"> > 75KW </td>
            <td *ngIf="sensorkw.metric_type === 'kwrating3' && assetType === 'COMPRESSOR'"> > 75KW </td>
            <td *ngIf="sensorkw.metric_type === 'kwrating3' && assetType === 'JOURNAL_BEARING'"> > 75KW </td>
            <td *ngIf="sensorkw.metric_type === 'kwrating3' && assetType === 'GEAR'"> Threshold </td>

            <td>
              <div class="flexnalign">
                <input type="number" id="display_base_val_dev{{ idx }}" value="{{ sensorkw.base_value }}"
                  class="form-control width_70 m_r_10" disabled="true" />

                <input type="number" id="threshold_1_dev{{ idx }}" value="{{ sensorkw.threshold_1 }}"
                  (input)="onInputChange()" class="form-control width_70" />
              </div>
            </td>

            <td>
              <div class="flexnalign">
                <input type="number" id="display_threshold_1_dev{{ idx }}" value="{{ sensorkw.threshold_1 }}"
                  class="form-control width_100 m_r_20" disabled="true" />

                <input type="number" id="threshold_2_dev{{ idx }}" value="{{ sensorkw.threshold_2 }}"
                  (input)="onInputChange()" class="form-control width_100" />
              </div>
            </td>

            <td>
              <div class="flexnalign">
                <input type="number" id="display_threshold_2_dev{{ idx }}" value="{{ sensorkw.threshold_2 }}"
                  class="form-control width_100 m_r_20" disabled="true" />

                <input type="number" id="threshold_3_dev{{ idx }}" value="{{ sensorkw.threshold_3 }}"
                  (input)="onInputChange()" class="form-control width_100" />
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <h4 *ngIf="showKurtosis" class="sub-title">Kurtosis</h4>
    <div *ngIf="showKurtosis" class="table-responsive">
      <table class="table">
        <thead>
          <tr>
            <th>Threshold</th>
            <th>Kurtosis Analysis Frequency (min)</th>
            <th>Anomaly Counter</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              <div class="flexnalign">
                <input type="number" id="kurt_threshold" value="{{ kurt_threshold }}" defaultValue="4"
                  (input)="onInputChange($event, _Sensor, 'max_value')" max="4" class="form-control width_100 m_r_20" />
              </div>
            </td>
            <td>
              <div class="flexnalign">
                <input type="number" id="kurt_frequency" (input)="onInputChange($event, _Sensor, 'max_value')"
                  value="{{ kurt_freq }}" max="8" min="6" class="form-control width_100 m_r_20" />
              </div>
            </td>
            <td>
              <div class="flexnalign">
                <input type="number" (input)="onInputChange($event, _Sensor, 'max_value')" id="kurt_anomaly_counter"
                  min="2" max="7" value="{{ kurt_anomaly_counter }}" class="form-control width_100 m_r_20" />
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <!-- <textarea class="form-control" placeholder=".....comment" [(ngModel)]="commentOnSetting"></textarea> -->
  </div>
  <div class="modal-footer">
    <button [disabled]="data.asset_status === 2" type="button" mat-raised-button color="primary" data-dismiss="modal"
      cdkFocusInitial (click)="saveSensorSettings()">
      Save
    </button>
    <button type="button" mat-stroked-button color="warn" data-dismiss="modal" [mat-dialog-close]="" cdkFocusInitial
      (click)="close()" cdkFocusInitial>
      Cancel
    </button>
  </div>
</div>